export default __webpack_public_path__ + "static/walgreens-e8bc214ead9f6c1bea31e97a736095a2.svg";